import './title-section.css';

function TitleSection({title}) {
    const normalizeBlueTitle = (value) => {
        const text = String(value || "").trim();
        if (!text) {
            return "";
        }
        const onlyLetters = text.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/g, "");
        const isMostlyUpper =
            onlyLetters.length > 0 && onlyLetters === onlyLetters.toUpperCase();

        if (!isMostlyUpper) {
            return text;
        }

        return text
            .toLocaleLowerCase("es-MX")
            .replace(/\b([a-záéíóúüñ])/g, (m) => m.toLocaleUpperCase("es-MX"));
    };

    return (
        <>
            <div className="title-section">
                <div className="title-section__container">
                <div className="title-section__content">
                    <h2>{normalizeBlueTitle(title)} </h2>
                </div>
                </div>
            </div>
        </>
    )
};

export default TitleSection;